import React from 'react';
import type { IconSource } from '@withjoy/joykit';
import { IconV1 } from '@withjoy/joykit';
import type { ButtonProps, SharedButtonStyleProps } from './Button.types';
import { StyledBaseButton, StyledButtonIcon, StyledButtonLabel, getButtonStyles } from './Button.styles';

export const Button: React.FC<ButtonProps> = props => {
  const {
    component = 'button',
    children,
    css,
    colorScheme = 'grey',
    iconStart,
    iconEnd,
    disabled,
    shape = 'default',
    size = 'default',
    truncate = false,
    variant = 'solid',
    ...restProps
  } = props;

  const sharedProps: SharedButtonStyleProps = {
    $isDisabled: !!disabled,
    $colorScheme: colorScheme,
    $shape: shape,
    $size: size,
    $variant: variant,
  };

  const renderIcon = (source: IconSource) => {
    return typeof source === 'string' ? <IconV1 source={source} /> : source;
  };

  return (
    <StyledBaseButton
      as={component}
      border="none"
      cursor="pointer"
      outline="none"
      display="inline-flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      fontFamily="'Inter UI'"
      fontWeight={600}
      fontStyle="normal"
      fontSize="0.9375rem"
      lineHeight="22px"
      letterSpacing="-0.13%"
      textDecoration="none"
      css={css}
      {...getButtonStyles(sharedProps)}
      {...restProps}
    >
      {iconStart && <StyledButtonIcon marginRight={!children && !iconEnd ? 0 : 3}>{renderIcon(iconStart)}</StyledButtonIcon>}
      {children && <StyledButtonLabel $truncate={truncate}>{children}</StyledButtonLabel>}
      {iconEnd && <StyledButtonIcon marginLeft={3}>{renderIcon(iconEnd)}</StyledButtonIcon>}
    </StyledBaseButton>
  );
};
